'use client';
import { useSimpleCommandPaletteModal } from '#pplx/frontend/apps/ask/command-palette/useSimpleCommandPaletteModal.js';
import { useRegisterShortcut } from '#pplx/frontend/apps/ask/keyboard-shortcuts-provider/registry.js';
import { useCallback } from 'react';
/**
 * Registers the global shortcut for opening the simple command palette:
 *   - macOS: Cmd+K
 *   - Windows/Linux: Ctrl+K
 *
 * Keybinding, label, and group are resolved from the shortcut manifest.
 */
export function useOpenCommandPaletteShortcut() {
    const { toggleSimpleCommandPalette } = useSimpleCommandPaletteModal();
    const handler = useCallback((e) => {
        e.preventDefault();
        toggleSimpleCommandPalette();
    }, [toggleSimpleCommandPalette]);
    useRegisterShortcut({
        id: 'open-command-palette',
        handler,
        isEnabled: true,
        isAvailable: true,
    });
}
//# sourceMappingURL=useOpenCommandPaletteShortcut.js.map